import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Select from 'components/Select';
import * as http from 'utils/http';
import config from 'config';
import { injectIntl } from 'react-intl';

import debouncePromise from 'debounce-promise';

import { StyledFilter, StyledSelectFilter } from 'components/ShipmentFilters/styled';
import { IS_TENANT } from 'tenant/config';

class ShipperField extends Component {
  static filterName = 'ShipperFilter';

  static propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.any,
    intl: PropTypes.any,
    clearable: PropTypes.bool,
    disabled: PropTypes.bool,
    invalid: PropTypes.bool,
    stylingProps: PropTypes.object.isRequired,
    sendAnalyticsEvents: PropTypes.func,
  };

  static defaultPropTypes = {
    clearable: true,
    disabled: false,
    invalid: false,
  };

  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.getShippers = debouncePromise(this.getShippers.bind(this), 500, { leading: true });
  }

  handleChange(value) {
    if (!this.props.onChange) {
      return;
    }
    const { onChange, sendAnalyticsEvents } = this.props;

    onChange(value, sendAnalyticsEvents);
  }

  async getShippers(input) {
    const { value } = this.props;

    if (!input || input.length < 3) {
      return Promise.resolve({ options: value ? [value] : [] });
    }

    const shippers = await http.get(
      `${config.API_URL}mercury/shippers/?search=${input}&page_size=0&ordering=company_name`
    );

    const options = {
      options: shippers || [],
    };

    return Promise.resolve(options);
  }

  render() {
    const { intl, value, clearable = true, disabled, invalid, stylingProps } = this.props;

    const t = intl.messages.components.ShipmentFilters;

    return (
      <StyledFilter {...stylingProps}>
        <StyledSelectFilter {...stylingProps} data-e2e="filters__shipper">
          <Select
            async
            disabled={disabled}
            invalid={invalid}
            placeholder={t.shipper_filter_placeholder}
            noResultsText={
              IS_TENANT ? 'There are no clients with that name' : t.shipper_filter_no_shippers
            }
            clearable={clearable}
            cache={false}
            ignoreAccents={false}
            ignoreCase={true}
            multi={false}
            value={value}
            filterOptions={false}
            onChange={this.handleChange}
            loadOptions={this.getShippers}
            valueKey="url"
            labelKey="company_name"
            onBlurResetsInput={true}
            small
          />
        </StyledSelectFilter>
      </StyledFilter>
    );
  }
}

export default injectIntl(ShipperField);
